import React from 'react';
import type { ReactElement } from 'react';
import type { ModalProps } from '@construct-kit/core';
import { Modal } from '@construct-kit/core';
import { useLockBodyScroll } from '../../searchResult/refinements/components/useLockBodyScroll';

const ModalWithScrollLock = ({
  opened,
  onRequestClose,
  getAppElement,
  children,
}: ModalProps): ReactElement => {
  useLockBodyScroll();
  return (
    <Modal opened={opened} onRequestClose={onRequestClose} getAppElement={getAppElement}>
      {children}
    </Modal>
  );
};

export default ModalWithScrollLock;
